import React from "react";
import { Link } from "react-router-dom";
import CloudinaryImage from "./components/CloudinaryImage";

// In order to show the original high res versions, we include the originals here
// and use cloudinary to do the compressed thumbnails only
import composite2025 from "./assets/2025_composite.jpg";
import composite2024 from "./assets/2024_composite.jpg";
import composite2023 from "./assets/2023_composite.jpg";
import composite2022 from "./assets/2022_composite.jpg";
import composite2021 from "./assets/2021_composite.jpg";
import composite2020 from "./assets/2020_composite.jpg";
import composite2019 from "./assets/2019_composite.jpg";
import composite2018 from "./assets/2018_composite.jpg";
import composite2017 from "./assets/2017_composite.jpg";
import composite2016 from "./assets/2016_composite.jpg";
import composite2015 from "./assets/2015_composite.jpg";
import composite2014 from "./assets/pre_2015_composite.jpg";


import hall_outdoors_front from "./assets/1_hall_outdoors_front.jpg";
import hall_outdoors_rear from "./assets/2_hall_outdoors_rear.jpg";
import audience_hall_rear from "./assets/3_audience_hall_rear.jpg";
import hall_interior_front from "./assets/4_hall_interior_front.jpg";
import hall_interior_back from "./assets/5_hall_interior_back.jpg";
import kitchen from "./assets/6_kitchen.jpg";

const posterImagesHash = {
  2025: {url: composite2025, cloudinary: "2025_composite", id: "2025", title: "2025" },
  2024: {url: composite2024, cloudinary: "2024_composite", id: "2024", title: "2024" },
  2023: {url: composite2023, cloudinary: "2023_composite", id: "2023", title: "2023" },
  2022: {url: composite2022, cloudinary: "2022_composite", id: "2022", title: "2022" },
  2021: {url: composite2021, cloudinary: "2021_composite", id: "2021", title: "2021" },
  2020: {url: composite2020, cloudinary: "2020_composite", id: "2020", title: "2020" },
  2019: {url: composite2019, cloudinary: "2019_composite", id: "2019", title: "2019" },
  2018: {url: composite2018, cloudinary: "2018_composite", id: "2018", title: "2018" },
  2017: {url: composite2017, cloudinary: "2017_composite", id: "2017", title: "2017" },
  2016: {url: composite2016, cloudinary: "2016_composite", id: "2016", title: "2016" },
  2015: {url: composite2015, cloudinary: "2015_composite", id: "2015", title: "2015" },
  2014: {url: composite2014, cloudinary: "pre_2015_composite", id: "2014", title: "2005 to 2014" },
};

const hallImagesHash = {
  hall_outdoors_front: {
    url: hall_outdoors_front,
    cloudinary: "1_hall_outdoors_front",
    id: "hall_outdoors_front",
    title: "Hall outdoors (front)",
  },
  hall_outdoors_rear: {
    url: hall_outdoors_rear,
    cloudinary: "2_hall_outdoors_rear",
    id: "hall_outdoors_rear",
    title: "Hall outdoors (rear)",
  },
  audience_hall_rear: {
    url: audience_hall_rear,
    cloudinary: "3_audience_hall_rear",
    id: "audience_hall_rear",
    title: "Audience / hall (rear)",
  },
  hall_interior_front: {
    url: hall_interior_front,
    cloudinary: "4_hall_interior_front",
    id: "hall_interior_front",
    title: "Hall interior (front)",
  },
  hall_interior_back: {
    url: hall_interior_back,
    cloudinary: "5_hall_interior_back",
    id: "hall_interior_back",
    title: "Hall interior (back)",
  },
  kitchen: {
    url: kitchen,
    cloudinary: "6_kitchen",
    id: "kitchen",
    title: "Kitchen",
  },
};

const posterImagesArray = Object.keys(posterImagesHash).map(key => posterImagesHash[key] );

const hallImagesArray = Object.keys(hallImagesHash).map(key => hallImagesHash[key] );

const allPhotosHash = {...hallImagesHash, ...posterImagesHash };

const cloudinaryPosterImages = posterImagesArray.map(
  (poster) => <Link key={poster.id} to={"gallery/" + poster.id} style={{margin: "1rem"}}>
    <CloudinaryImage name={poster.cloudinary} width={240} />
  </Link>
).reverse();

const cloudinaryHallImages = hallImagesArray.map(
  (poster) => <Link key={poster.id} to={"gallery/" + poster.id} style={{margin: "1rem"}}>
    <CloudinaryImage name={poster.cloudinary} width={240} />
  </Link>
);

export {cloudinaryPosterImages, allPhotosHash, cloudinaryHallImages };
